"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAssistantPlanningWeekApiResponseSchema = exports.generateAssistantPlanningWeekApiPayloadSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.generateAssistantPlanningWeekApiPayloadSchema = zod_1.z.object({
    officeId: zod_1.z.string(),
    assistantId: zod_1.z.string(),
    week: zod_1.z.string().regex(/^\d{4}-W\d{2}$/),
    templateWeek: enums_1.templateWeekSchema,
});
exports.generateAssistantPlanningWeekApiResponseSchema = zod_1.z.object({
    created: zod_1.z.number().int().min(0),
    overwritten: zod_1.z.number().int().min(0),
    cancelled: zod_1.z.number().int().min(0),
    skipped: zod_1.z.number().int().min(0),
});
